export function hasFoodMoverCompletionAuthority({
  user,
  foodRun,
  drivers = [],
}) {
  if (!user || !foodRun) {
    return false;
  }

  const isAssignedDriver = drivers.some((driver) => driver.user_id === user.id);

  return (
    user.team_id === foodRun.food_mover_team_id &&
    (!user.is_driver || isAssignedDriver)
  );
}

export function canEditFoodRun({ user, foodRun }) {
  const moverTeamId =
    foodRun?.food_mover_team_id ?? foodRun?.donation_team_id ?? null;

  if (!user?.team_id || !moverTeamId) {
    return false;
  }

  return user.team_id === moverTeamId;
}

// Whether unassigning removes only the current user from the run. Mirrors the
// server's isSelfUnassign (getUnassignRunnerAccess): a driver on the run
// removes only themselves, unless they are admin/staff of the team that
// manages the run, who release it from every driver.
export function isFoodRunSelfUnassign({ user, foodRun, drivers = [] }) {
  if (!user || !foodRun) {
    return false;
  }

  const isAssignedDriver = drivers.some(
    (driver) => String(driver.user_id) === String(user.id)
  );
  const isOwnerTeamManager =
    !user.is_driver && canEditFoodRun({ user, foodRun });

  return isAssignedDriver && !isOwnerTeamManager;
}

// Donor and recipient teams get weights-only entry; the mover team completes.
// The run's assigned drivers complete it from any org they're switched into,
// e.g. a mover-team driver who also belongs to the recipient org.
export function shouldUseWeightsOnlyMode({
  user,
  foodRun,
  drivers = [],
  status,
}) {
  const teamId = user?.team_id;
  const isDonorTeam = teamId === foodRun?.donor_team;
  const isRecipientTeam =
    teamId === (foodRun?.receiver_team ?? foodRun?.recipient_team_id);
  const isAssignedDriver = drivers.some(
    (driver) => driver.user_id === user?.id
  );
  return (
    status !== 'COMPLETED' &&
    (isDonorTeam || isRecipientTeam) &&
    !isAssignedDriver &&
    !hasFoodMoverCompletionAuthority({ user, foodRun, drivers })
  );
}
